import React from "react";
import { Chat, Phone } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

const phoneNumber = "3472803596";
const messageTemplate =
  "Hi, I'm interested in learning more about your services.";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="pc-footer">
      <div className="pc-footer__grid">
        <div className="pc-footer__col">
          <h4>Quick links</h4>
          <a href="https://www.NeedForGeeks.com" target="_blank" rel="noopener noreferrer">Main site</a><br />
          <Link to="/How-To-Pay">How to pay</Link><br />
          <Link to="/Referrals-Affiliates">Referrals & affiliates</Link><br />
          <Link to="/Become-a-Developer">Become a developer</Link><br />
          <Link to="/Terms-And-Conditions">Terms & conditions</Link>
        </div>

        <div className="pc-footer__col">
          <h4>Talk to us</h4>
          <div className="pc-footer__phone">(347) 280-3596</div>
          <Button
            className="pc-footer__cta"
            startIcon={<Phone />}
            href={"tel: " + phoneNumber}
          >
            Call
          </Button>
          <Button
            className="pc-footer__cta"
            startIcon={<Chat />}
            href={"sms: " + phoneNumber + "&body=" + messageTemplate}
          >
            Text
          </Button>
        </div>

        <div className="pc-footer__col">
          <h4>We're here for you</h4>
          <p style={{ fontSize: "0.92rem", lineHeight: 1.55, margin: 0 }}>
            Serving New York for over five years —
            quietly making invitations a little more thoughtful.
          </p>
        </div>
      </div>

      <div className="pc-footer__rule" aria-hidden />

      <div className="pc-footer__legal">
        © {year} ·{" "}
        <a
          rel="noopener"
          href="https://github.com/NeedForGeeksNY"
          aria-label="NeedForGeeks GitHub"
        >
          NeedForGeeks
        </a>
        {" "}— made in New York.
      </div>
    </footer>
  );
};

export default Footer;
